import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { getFrameworkAppSettings } from '../fasApi';
import { COLLABORATION_SIDEBAR_FAS_NAMESPACE, COMMENTING_FAS_NAMESPACE } from '../constants';
import { LEGACY_COMMENT_OBJECT_TYPES } from '../../../constants/CommentObjectType';
import { registerQuery, useQuery } from 'data-fetching-client';
const FAS_QUERY = registerQuery({
  fieldName: 'collaborationSidebarFAS',
  args: [],
  fetcher: () => getFrameworkAppSettings()
});
export default function useFrameworkAppSettings(t0) {
  "use memo";

  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    skip: t2
  } = t1;
  const skip = t2 === undefined ? false : t2;
  let t3;
  if ($[2] !== skip) {
    t3 = {
      skip
    };
    $[2] = skip;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: appSettingsData,
    loading,
    error
  } = useQuery(FAS_QUERY, t3);
  const appSettings = appSettingsData === null || appSettingsData === void 0 ? void 0 : appSettingsData.collaborationSidebarFAS;
  let t4;
  if ($[4] !== appSettings) {
    t4 = appName => {
      var _appSettings$appName;
      return (appSettings === null || appSettings === void 0 || (_appSettings$appName = appSettings[appName]) === null || _appSettings$appName === void 0 || (_appSettings$appName = _appSettings$appName[COLLABORATION_SIDEBAR_FAS_NAMESPACE]) === null || _appSettings$appName === void 0 ? void 0 : _appSettings$appName.metadata) || null;
    };
    $[4] = appSettings;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getCollaborationSidebarAppSetting = t4;
  let t5;
  if ($[6] !== appSettings) {
    t5 = objectTypeId => {
      var _appSettings$objectTy;
      if (LEGACY_COMMENT_OBJECT_TYPES.includes(objectTypeId)) {
        return {
          enabled: {
            value: true
          }
        };
      }
      return (appSettings === null || appSettings === void 0 || (_appSettings$objectTy = appSettings[objectTypeId]) === null || _appSettings$objectTy === void 0 || (_appSettings$objectTy = _appSettings$objectTy[COMMENTING_FAS_NAMESPACE]) === null || _appSettings$objectTy === void 0 ? void 0 : _appSettings$objectTy.metadata) || null;
    };
    $[6] = appSettings;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const getCommentingAppSetting = t5;
  let t6;
  if ($[8] !== error || $[9] !== getCollaborationSidebarAppSetting || $[10] !== getCommentingAppSetting || $[11] !== loading) {
    t6 = {
      getCollaborationSidebarAppSetting,
      getCommentingAppSetting,
      loading,
      error
    };
    $[8] = error;
    $[9] = getCollaborationSidebarAppSetting;
    $[10] = getCommentingAppSetting;
    $[11] = loading;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}